export default __webpack_public_path__ + "static/media/mdiab_afrika_bg.2bf86eec.jpg";